import styled from "styled-components";
import Tag from "./Tag";

const DateTag = styled(Tag)`
    background-color: rgb(16, 185, 129);
`;

export default DateTag;